(function () {
  'use strict';

  /* ---- Header toggles (delegated so they survive theme editor re-renders) ---- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-toggle]');
    if (toggle) {
      var target = document.getElementById(toggle.getAttribute('data-toggle'));
      if (target) {
        var open = target.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          var input = target.querySelector('input[type="search"]');
          if (input) input.focus();
        }
      }
    }

    /* Quantity steppers */
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var wrap = step.closest('.qty');
      var field = wrap && wrap.querySelector('input');
      if (field) {
        var val = parseInt(field.value, 10) || 1;
        val += parseInt(step.getAttribute('data-qty-step'), 10);
        field.value = Math.max(field.min === '0' ? 0 : 1, val);
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    /* Gallery thumbnails */
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      var root = thumb.closest('[data-product-section]');
      if (root) activateImage(root, thumb.getAttribute('data-thumb'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.search-panel.is-open, .mobile-nav.is-open').forEach(function (el) {
        el.classList.remove('is-open');
      });
    }
  });

  /* ---- Auto-submit: collection filters/sort, cart quantities ---- */
  document.addEventListener('change', function (e) {
    var filterForm = e.target.closest('[data-filter-form]');
    if (filterForm) {
      filterForm.submit();
      return;
    }
    var sortSelect = e.target.closest('[data-sort-select]');
    if (sortSelect) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
      return;
    }
    var cartQty = e.target.closest('[data-cart-qty]');
    if (cartQty) {
      var form = cartQty.closest('form');
      var btn = form && form.querySelector('[name="update"]');
      if (btn) btn.click();
    }
  });

  /* ---- Product gallery ---- */
  function activateImage(root, imageId) {
    var found = false;
    root.querySelectorAll('[data-slide]').forEach(function (slide) {
      var on = slide.getAttribute('data-slide') === String(imageId);
      slide.classList.toggle('is-active', on);
      if (on) found = true;
    });
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(imageId));
    });
    return found;
  }

  /* ---- Product variants ---- */
  function initProduct(root) {
    var dataEl = root.querySelector('[data-variant-data]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var idInput = root.querySelector('input[name="id"]');
    var addBtn = root.querySelector('[data-add-button]');
    var priceEl = root.querySelector('[data-price]');
    var payBtn = root.querySelector('.shopify-payment-button');

    function selectedOptions() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option-group]'), function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function update() {
      var selected = selectedOptions();
      var variant = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });

      if (addBtn) {
        if (!variant) {
          addBtn.disabled = true;
          addBtn.querySelector('span').textContent = 'Unavailable';
        } else if (!variant.available) {
          addBtn.disabled = true;
          addBtn.querySelector('span').textContent = 'Sold out';
        } else {
          addBtn.disabled = false;
          addBtn.querySelector('span').textContent = addBtn.getAttribute('data-label') || 'Add to cart';
        }
      }
      if (payBtn) payBtn.style.display = variant && variant.available ? '' : 'none';
      if (!variant) return;

      if (idInput) idInput.value = variant.id;
      if (priceEl) {
        priceEl.innerHTML = (variant.compare ? '<s>' + variant.compare + '</s>' : '') + '<span>' + variant.price + '</span>';
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      if (variant.image) activateImage(root, variant.image);
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-input]')) update();
    });
  }

  /* ---- Product recommendations ---- */
  function initRecommendations(el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.querySelector('.card')) {
          el.innerHTML = fresh.innerHTML;
          var section = el.closest('[data-recommendations-section]');
          if (section) section.hidden = false;
        }
      })
      .catch(function () {});
  }

  function boot() {
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
    document.querySelectorAll('[data-recommendations]').forEach(initRecommendations);
  }

  boot();
  document.addEventListener('shopify:section:load', boot);
})();
